export interface DistrictInterface {
  id: number;
  province_id: number;
  name: string;
  area_sq_km: string;
  website: string;
  headquarter: string;
}

export const Districts: DistrictInterface[] = [
  {
    id: 1,
    province_id: 1,
    name: "Bhojpur",
    area_sq_km: "1507",
    website: "https://www.ddcbhojpur.gov.np",
    headquarter: "Bhojpur",
  },
  {
    id: 2,
    province_id: 1,
    name: "Dhankuta",
    area_sq_km: "892",
    website: "https://www.ddcdhankuta.gov.np",
    headquarter: "Dhankuta",
  },
  {
    id: 3,
    province_id: 1,
    name: "Ilam",
    area_sq_km: "1703",
    website: "https://www.ddcilam.gov.np",
    headquarter: "Ilam",
  },
  {
    id: 4,
    province_id: 1,
    name: "Jhapa",
    area_sq_km: "1606",
    website: "https://www.ddcjhapa.gov.np",
    headquarter: "Bhadrapur",
  },
  {
    id: 5,
    province_id: 1,
    name: "Khotang",
    area_sq_km: "1591",
    website: "https://www.dcckhotang.gov.np",
    headquarter: "Diktel",
  },
  {
    id: 6,
    province_id: 1,
    name: "Morang",
    area_sq_km: "1855",
    website: "https://www.ddcmorang.gov.np",
    headquarter: "Biratnagar",
  },
  {
    id: 7,
    province_id: 1,
    name: "Okhaldhunga",
    area_sq_km: "1074",
    website: "https://www.dccokhaldhunga.gov.np/en",
    headquarter: "Siddhicharan",
  },
  {
    id: 8,
    province_id: 1,
    name: "Pachthar",
    area_sq_km: "1241",
    website: "https://www.ddcpanchthar.gov.np",
    headquarter: "Phidim",
  },
  {
    id: 9,
    province_id: 1,
    name: "Sankhuwasabha",
    area_sq_km: "3480",
    website: "https://www.ddcsankhuwasabha.gov.np",
    headquarter: "Khandbari",
  },
  {
    id: 10,
    province_id: 1,
    name: "Solukhumbu",
    area_sq_km: "3312",
    website: "https://www.ddcsolukhumbu.gov.np",
    headquarter: "Salleri",
  },
  {
    id: 11,
    province_id: 1,
    name: "Sunsari",
    area_sq_km: "1257",
    website: "https://www.ddcsunsari.gov.np",
    headquarter: "Inaruwa",
  },
  {
    id: 12,
    province_id: 1,
    name: "Taplejung",
    area_sq_km: "3646",
    website: "https://www.ddctaplejung.gov.np",
    headquarter: "Taplejung",
  },
  {
    id: 13,
    province_id: 1,
    name: "Terhathum",
    area_sq_km: "679",
    website: "https://www.ddctehrathum.gov.np",
    headquarter: "Myanglung",
  },
  {
    id: 14,
    province_id: 1,
    name: "Udayapur",
    area_sq_km: "2063",
    website: "https://www.ddcudayapur.gov.np",
    headquarter: "Gaighat",
  },
  {
    id: 15,
    province_id: 2,
    name: "Parsa",
    area_sq_km: "1353",
    website: "https://dccparsa.gov.np/",
    headquarter: "Birgunj",
  },
  {
    id: 16,
    province_id: 2,
    name: "Bara",
    area_sq_km: "1190",
    website: "https://dccbara.gov.np/",
    headquarter: "Kalaiya",
  },
  {
    id: 17,
    province_id: 2,
    name: "Rautahat",
    area_sq_km: "1126",
    website: "https://dccrautahat.gov.np/",
    headquarter: "Gaur",
  },
  {
    id: 18,
    province_id: 2,
    name: "Sarlahi",
    area_sq_km: "1259",
    website: "https://dccsarlahi.gov.np/",
    headquarter: "Malangawa",
  },
  {
    id: 19,
    province_id: 2,
    name: "Siraha",
    area_sq_km: "1188",
    website: "https://dccsiraha.gov.np/",
    headquarter: "Siraha",
  },
  {
    id: 20,
    province_id: 2,
    name: "Dhanusha",
    area_sq_km: "1180",
    website: "https://dccdhanusha.gov.np/",
    headquarter: "Janakpur",
  },
  {
    id: 21,
    province_id: 2,
    name: "Saptari",
    area_sq_km: "1363",
    website: "https://dccsaptari.gov.np/",
    headquarter: "Rajbiraj",
  },
  {
    id: 22,
    province_id: 2,
    name: "Mahottari",
    area_sq_km: "1002",
    website: "https://dccmahottari.gov.np/",
    headquarter: "Jaleshwar",
  },
  {
    id: 23,
    province_id: 3,
    name: "Bhaktapur",
    area_sq_km: "119",
    website: "https://dccbhaktapur.gov.np/",
    headquarter: "Bhaktapur",
  },
  {
    id: 24,
    province_id: 3,
    name: "Chitwan",
    area_sq_km: "2218",
    website: "https://dccchitwan.gov.np/",
    headquarter: "Bharatpur",
  },
  {
    id: 25,
    province_id: 3,
    name: "Dhading",
    area_sq_km: "1926",
    website: "https://dccdhading.gov.np/",
    headquarter: "Nilkantha",
  },
  {
    id: 26,
    province_id: 3,
    name: "Dolakha",
    area_sq_km: "2191",
    website: "https://dccdolakha.gov.np/",
    headquarter: "Bhimeshwar",
  },
  {
    id: 27,
    province_id: 3,
    name: "Kathmandu",
    area_sq_km: "395",
    website: "https://dccktm.gov.np/",
    headquarter: "Kathmandu",
  },
  {
    id: 28,
    province_id: 3,
    name: "Kavrepalanchok",
    area_sq_km: "1396",
    website: "https://dcckavre.gov.np/",
    headquarter: "Dhulikhel",
  },
  {
    id: 29,
    province_id: 3,
    name: "Lalitpur",
    area_sq_km: "385",
    website: "https://dcclalitpur.gov.np/",
    headquarter: "Lalitpur",
  },
  {
    id: 30,
    province_id: 3,
    name: "Makwanpur",
    area_sq_km: "2426",
    website: "https://dccmakwanpur.gov.np/",
    headquarter: "Hetauda",
  },
  {
    id: 31,
    province_id: 3,
    name: "Nuwakot",
    area_sq_km: "1121",
    website: "https://dccnuwakot.gov.np/",
    headquarter: "Bidur",
  },
  {
    id: 32,
    province_id: 3,
    name: "Ramechap",
    area_sq_km: "1546",
    website: "https://dccramechhap.gov.np/",
    headquarter: "Manthali",
  },
  {
    id: 33,
    province_id: 3,
    name: "Rasuwa",
    area_sq_km: "1544",
    website: "https://dccrasuwa.gov.np/",
    headquarter: "Dhunche",
  },
  {
    id: 34,
    province_id: 3,
    name: "Sindhuli",
    area_sq_km: "2491",
    website: "https://dccsindhuli.gov.np/",
    headquarter: "Kamalamai",
  },
  {
    id: 35,
    province_id: 3,
    name: "Sindhupalchok",
    area_sq_km: "2542",
    website: "https://dccsindhupalchowk.gov.np/",
    headquarter: "Chautara",
  },
  {
    id: 36,
    province_id: 4,
    name: "Baglung",
    area_sq_km: "1784",
    website: "https://dccbaglung.gov.np/",
    headquarter: "Baglung",
  },
  {
    id: 37,
    province_id: 4,
    name: "Gorkha",
    area_sq_km: "3610",
    website: "https://dccgorkha.gov.np/",
    headquarter: "Gorkha",
  },
  {
    id: 38,
    province_id: 4,
    name: "Kaski",
    area_sq_km: "2017",
    website: "https://dcckaski.gov.np/",
    headquarter: "Pokhara",
  },
  {
    id: 39,
    province_id: 4,
    name: "Lamjung",
    area_sq_km: "1692",
    website: "https://dcclamjung.gov.np/",
    headquarter: "Besisahar",
  },
  {
    id: 40,
    province_id: 4,
    name: "Manang",
    area_sq_km: "2246",
    website: "https://dccmanang.gov.np/",
    headquarter: "Chame",
  },
  {
    id: 41,
    province_id: 4,
    name: "Mustang",
    area_sq_km: "3573",
    website: "https://dccmustang.gov.np/",
    headquarter: "Jomsom",
  },
  {
    id: 42,
    province_id: 4,
    name: "Myagdi",
    area_sq_km: "2297",
    website: "https://dccmyagdi.gov.np/",
    headquarter: "Beni",
  },
  {
    id: 43,
    province_id: 4,
    name: "Nawalpur",
    area_sq_km: "1043.1",
    website: "https://dccnawalparasi.gov.np/",
    headquarter: "Kawasoti",
  },
  {
    id: 44,
    province_id: 4,
    name: "Parwat",
    area_sq_km: "494",
    website: "https://dccparbat.gov.np/",
    headquarter: "Kusma",
  },
  {
    id: 45,
    province_id: 4,
    name: "Syangja",
    area_sq_km: "1164",
    website: "https://dccsyangja.gov.np/",
    headquarter: "Putalibazar",
  },
  {
    id: 46,
    province_id: 4,
    name: "Tanahun",
    area_sq_km: "1546",
    website: "https://dcctanahun.gov.np/",
    headquarter: "Damauli",
  },
  {
    id: 47,
    province_id: 5,
    name: "Kapilvastu",
    area_sq_km: "1738",
    website: "https://dcckapilvastu.gov.np/",
    headquarter: "Taulihawa",
  },
  {
    id: 48,
    province_id: 5,
    name: "Parasi",
    area_sq_km: "634.88",
    website: "https://dccnawalparasi.gov.np/",
    headquarter: "Ramgram",
  },
  {
    id: 49,
    province_id: 5,
    name: "Rupandehi",
    area_sq_km: "1360",
    website: "https://dccrupandehi.gov.np/",
    headquarter: "Siddharthanagar",
  },
  {
    id: 50,
    province_id: 5,
    name: "Arghakhanchi",
    area_sq_km: "1193",
    website: "https://dccargakhanchi.gov.np/",
    headquarter: "Sandhikharka",
  },
  {
    id: 51,
    province_id: 5,
    name: "Gulmi",
    area_sq_km: "1149",
    website: "https://dccgulmi.gov.np/",
    headquarter: "Tamghas",
  },
  {
    id: 52,
    province_id: 5,
    name: "Palpa",
    area_sq_km: "1373",
    website: "https://dccpalpa.gov.np/",
    headquarter: "Tansen",
  },
  {
    id: 53,
    province_id: 5,
    name: "Dang",
    area_sq_km: "2955",
    website: "https://dccdang.gov.np/",
    headquarter: "Ghorahi",
  },
  {
    id: 54,
    province_id: 5,
    name: "Pyuthan",
    area_sq_km: "1309",
    website: "https://dccpyuthan.gov.np/",
    headquarter: "Pyuthan",
  },
  {
    id: 55,
    province_id: 5,
    name: "Rolpa",
    area_sq_km: "1879",
    website: "https://dccrolpa.gov.np/",
    headquarter: "Liwang",
  },
  {
    id: 56,
    province_id: 5,
    name: "Eastern Rukum",
    area_sq_km: "1161.13",
    website: "https://dccrukum.gov.np/",
    headquarter: "Rukumkot",
  },
  {
    id: 57,
    province_id: 5,
    name: "Banke",
    area_sq_km: "2337",
    website: "https://dccbanke.gov.np/",
    headquarter: "Nepalganj",
  },
  {
    id: 58,
    province_id: 5,
    name: "Bardiya",
    area_sq_km: "2025",
    website: "https://dccbardiya.gov.np/",
    headquarter: "Gulariya",
  },
  {
    id: 59,
    province_id: 6,
    name: "Western Rukum",
    area_sq_km: "1213.49",
    website: "https://dccrukum.gov.np/",
    headquarter: "Musikot",
  },
  {
    id: 60,
    province_id: 6,
    name: "Salyan",
    area_sq_km: "1462",
    website: "https://dccsalyan.gov.np/",
    headquarter: "Salyan",
  },
  {
    id: 61,
    province_id: 6,
    name: "Dolpa",
    area_sq_km: "7889",
    website: "https://dccdolpa.gov.np/",
    headquarter: "Dunai",
  },
  {
    id: 62,
    province_id: 6,
    name: "Humla",
    area_sq_km: "5655",
    website: "https://dcchumla.gov.np/",
    headquarter: "Simikot",
  },
  {
    id: 63,
    province_id: 6,
    name: "Jumla",
    area_sq_km: "2531",
    website: "https://dccjumla.gov.np/",
    headquarter: "Chandannath",
  },
  {
    id: 64,
    province_id: 6,
    name: "Kalikot",
    area_sq_km: "1741",
    website: "https://dcckalikot.gov.np/",
    headquarter: "Manma",
  },
  {
    id: 65,
    province_id: 6,
    name: "Mugu",
    area_sq_km: "3535",
    website: "https://dccmugu.gov.np/",
    headquarter: "Gamgadhi",
  },
  {
    id: 66,
    province_id: 6,
    name: "Surkhet",
    area_sq_km: "2451",
    website: "https://dccsurkhet.gov.np/",
    headquarter: "Birendranagar",
  },
  {
    id: 67,
    province_id: 6,
    name: "Dailekh",
    area_sq_km: "1502",
    website: "https://dccdailekh.gov.np/",
    headquarter: "Dailekh",
  },
  {
    id: 68,
    province_id: 6,
    name: "Jajarkot",
    area_sq_km: "2230",
    website: "https://dccjajarkot.gov.np/",
    headquarter: "Khalanga",
  },
  {
    id: 69,
    province_id: 7,
    name: "Darchula",
    area_sq_km: "2344.61",
    website: "https://ddcdarchula.gov.np/",
    headquarter: "Darchula",
  },
  {
    id: 70,
    province_id: 7,
    name: "Bajhang",
    area_sq_km: "3394.21",
    website: "https://dccbajhang.gov.np/",
    headquarter: "Jayaprithvi",
  },
  {
    id: 71,
    province_id: 7,
    name: "Bajura",
    area_sq_km: "2300.34",
    website: "https://dccbajura.gov.np/",
    headquarter: "Badimalika",
  },
  {
    id: 72,
    province_id: 7,
    name: "Baitadi",
    area_sq_km: "1496.04",
    website: "https://dccbaitadi.gov.np/",
    headquarter: "Dasharathchand",
  },
  {
    id: 73,
    province_id: 7,
    name: "Doti",
    area_sq_km: "2295.71",
    website: "https://dccdoti.gov.np/",
    headquarter: "Dipayal Silgadhi",
  },
  {
    id: 74,
    province_id: 7,
    name: "Acham",
    area_sq_km: "1692",
    website: "https://dccacham.gov.np/",
    headquarter: "Mangalsen",
  },
  {
    id: 75,
    province_id: 7,
    name: "Dadeldhura",
    area_sq_km: "1506.09",
    website: "https://dccdadeldhura.gov.np/",
    headquarter: "Amargadhi",
  },
  {
    id: 76,
    province_id: 7,
    name: "Kanchanpur",
    area_sq_km: "1222.31",
    website: "https://dcckanchanpur.gov.np/",
    headquarter: "Bheemdatta",
  },
  {
    id: 77,
    province_id: 7,
    name: "Kailali",
    area_sq_km: "3292.35",
    website: "https://dcckailali.gov.np/",
    headquarter: "Dhangadhi",
  },
];
